// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import RemindRoundSvg from '@rsuite/icon-font/lib/status/RemindRound';
var RemindRound = createSvgIcon({
    as: RemindRoundSvg,
    ariaLabel: 'remind round',
    category: 'status',
    displayName: 'RemindRound'
});
export default RemindRound;
